import { memo } from "react";
import { isValid } from "date-fns";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import { HistoryDetailsBaseRow } from "./historyDetailsBaseRow";
import styles from "./HistoryDetailsCells.module.scss";

interface HistoryDetailsDateCellProps {
    row: { original: HistoryDetailsBaseRow };
}

export const HistoryDetailsDateCell = memo(
    ({ row }: HistoryDetailsDateCellProps) => {
        const { date, dateOnly } = row.original;
        let dateLabel = "-";
        if (dateOnly) {
            dateLabel = formatDateOnly(dateOnly);
        } else if (isValid(new Date(date))) {
            dateLabel = formatBusinessDate(new Date(date));
        }

        return (
            <ViewTableCell className={styles.dateCell}>
                {dateLabel}
            </ViewTableCell>
        );
    },
);

HistoryDetailsDateCell.displayName = "HistoryDetailsDateCell";
